// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Trend_wrapper__3yRLB","content":"Trend_content__10Eyh"};